export enum EnumTipoItemTexto {
  tituloPrincipal = 1,
  preambulo = 2,
  parte = 3,
  livro = 4,
  titulo = 5,
  ementa = 6,
  capitulo = 7,
  secao = 8,
  subSecao = 9,
  artigo = 10,
  paragrafo = 11,
  inciso = 12,
  alinea = 13,
  rodape = 14,
  sumula = 15,
  incisoSumula = 16,
  rodapeSumula = 17,
  paragrafoInternacional = 18,
  alineaInternacional = 19,
  incisoInternacional = 20,
  linhaTabela = 98,
  desconhecido = 99,
}
